/**
 * Componente: DashboardHeader
 * Header melhorado para a nova dashboard
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import { ThemeToggle } from '@/components/common';
import { GlobalSearch, NotificationCenter } from './HeaderActions';

interface DashboardHeaderProps {
  userName: string;
}

export function DashboardHeader({
  userName,
}: DashboardHeaderProps) {
  return (
    <header className="bg-white dark:bg-neutral-900 border-b border-gray-200 dark:border-neutral-800 px-8 py-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
            Admin Dashboard
          </h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
            Bem-vindo de volta, {userName}. Aqui está o que está acontecendo hoje.
          </p>
        </div>

        <div className="flex items-center gap-4">
          <GlobalSearch />
          <NotificationCenter />

          <button className="p-2.5 hover:bg-gray-100 dark:hover:bg-neutral-800 rounded-lg transition-colors">
            <HelpCircle className="w-5 h-5 text-gray-600 dark:text-gray-400" />
          </button>

          <ThemeToggle />
        </div>
      </div>
    </header>
  );
}
